import uniqBy from 'lodash.uniqby'
import { Presence } from './types'

const SEVERALPEOPLE_BREAKPOINT = 2

export const isOwnUser = function (
  presence: Presence,
  userIdentifier?: string
) {
  return presence.user.identifier === userIdentifier
}

const getPresenceText = function (
  presences: Presence[],
  includesOwnUser: boolean = false
) {
  if (presences.length >= SEVERALPEOPLE_BREAKPOINT || includesOwnUser) {
    return 'are editing'
  }

  return 'is editing'
}

const getPresenceNames = function (
  presences: Presence[],
  includesOwnUser: boolean = false
) {
  if (presences.length >= SEVERALPEOPLE_BREAKPOINT) {
    return 'Several people'
  }

  if (includesOwnUser) {
    return 'You'
  }

  return presences[0].user.name
}

export const getPresenceMessage = function (
  presences: Presence[],
  ownUserIdentifier?: string
) {
  const includesOwnUser = presences.some(presence =>
    isOwnUser(presence, ownUserIdentifier)
  )

  return {
    names: getPresenceNames(presences, includesOwnUser),
    message: getPresenceText(presences, includesOwnUser),
  }
}

export const getUniquePresences = function (presences: Presence[] = []) {
  return uniqBy(presences, 'user.identifier')
}

export function transformPropertyNames(presences: any[]): Presence[] {
  return presences.map(presence => ({
    currentPage: presence.current_page,
    followable: presence.followable,
    following: presence.following,
    id: presence.id,
    user: {
      avatarUrl: presence.user.avatar_url,
      identifier: presence.user.identifier,
      kind: presence.user.kind,
      name: presence.user.name,
    },
  }))
}
